import styled from "styled-components";

const ModalContainer = styled.div`
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  background-color: white;
  padding: 50px 40px 40px 40px;
  border-radius: 8px;
  text-align: center;
  min-width: 350px;
  min-height: fit-content;

  &:focus {
    outline: none;
  }
`;

const CloseIcon = styled.i`
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
`;

export { CloseIcon, ModalContainer };
